import React from 'react';
import { Box, Grid, Typography, styled } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../redux/hooks';
import { capitalizeWords } from '../ClientDetail/Legend';
import { renderActivitySchedule } from './Progress';
import { setClientProgressBlock } from '../../redux/client/clientSlice';
import AdavanceActivityCharts from './AdavanceActivityCharts';
import { ActivityTypeEnum } from '../../types/activity';
import Answers from './AnswersTable/Answers';
import ProgressDetailsTable from './ProgressDetailsTable';

const StyledBox = styled(Box)(() => ({
  borderRadius: '50%',
  display: 'flex',
  p: '12px',
  justifyContent: 'center',
  alignItems: 'center',
  width: '32px',
  height: '32px',
  background: 'var(--Brand-Cadet-Blue, linear-gradient(138deg, #6599A5 24.11%, #3B667E 83.2%))',
  cursor: 'pointer',
}));

function SingleActivityProgress() {
  const activity = useAppSelector((state) => state.client.activity);
  const dispatch = useDispatch();

  const handlePrevious = () => {
    dispatch(setClientProgressBlock());
  };

  return (
    <Grid
      mt="24px"
      display="flex"
      flexDirection="column"
      gap={6}
      height="75vh"
      sx={{
        overflowX: 'hidden',
        overflowY: 'scroll',
        paddingRight: '10px',
        '&::-webkit-scrollbar': {
          width: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(93,171,201,0.5)',
          borderRadius: '10px',
        },
      }}
    >
      <Grid display="flex" gap={2} flexDirection="column">
        <Grid gap="12px" display="flex" flexDirection="row" alignItems="center">
          <StyledBox onClick={handlePrevious}>
            <img src="/assets/icons/alt-arrow-left.svg" alt="alt-arrow-left" />
          </StyledBox>
          <Typography variant="h6" color="primary">
            {capitalizeWords(activity.name)}
          </Typography>
          {renderActivitySchedule(activity.schedule as ActivityTypeEnum)}
        </Grid>
        <AdavanceActivityCharts activity={activity} />
        {!activity.activityDetails.some((e) => e.isAdvanceActivity) && <ProgressDetailsTable />}
      </Grid>
      <Grid>{activity.activityDetails.some((e) => e.isAdvanceActivity) && <Answers />}</Grid>
    </Grid>
  );
}

export default SingleActivityProgress;
